import React, { useState, useEffect, useRef, useMemo } from 'react'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { connect, useDispatch } from 'react-redux'
import { useRouter } from 'next/router'
import Container from '@material-ui/core/Container'
import clsx from 'clsx'
import InformationForm from '../components/Information/InformationForm'
import Layout from '../components/Layout/Layout'
import FunnelHeader from '../components/Funnel/FunnelHeader'
import FunnelBox from '../components/Funnel/FunnelBox'
import FunnelAside from '../components/Funnel/FunnelAside'
import useFunnelStyle from '../components/Funnel/Funnel.style'
import { createCheckoutAdress, getCheckout } from '../redux/actions/checkout'
import { Cart, BillingAddress, ShippingAddress } from '../typings/base'
import {
  loginUser,
  registerUser,
  getUser,
  saveGhostUser,
  deleteGhostUser,
} from '../redux/actions/user'
import LoginForm from '../components/UserForm/LoginForm'
import RegisterForm from '../components/UserForm/RegisterFrom'
import ConnectedForm from '../components/UserForm/ConnectedForm'
import Link from '../components/Link/Link'
import { Typography } from '@material-ui/core'
import ForgotPasswordForm from '../components/UserForm/ForgotPasswordForm'
import { postAddress } from '../redux/actions/addressUser'
import { getTranslations } from '../i18n'
import { useTranslation } from 'react-i18next'
import { checkTryOutError, setFullLocale } from '../utils/utils'
import { useCartHasStockError } from '@/hooks/useCartHasStockError'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import Loader from '../components/Loader/Loader'
import parseMax from 'libphonenumber-js/max'
import CMSText, { prismicText } from '../components/Global/CMSText'
import { SAVE_PRISMIC_DOCUMENTS } from '../redux/actions/prismic'
import { createClient, getSingleDocument } from '../prismicio'
import { isB2B, isThermorSSO, LOCAL_STORAGE_KEYS } from '@/utils/constants'
import { getStepperSteps } from '@/utils/funnel'
import { GetMapDispatchTypes } from '../interfaces/common/redux'
import { RootState } from '../redux/reducers/rootReducer'
import {
  getLastUsedBillingAddress,
  setInformationSkipped,
} from '../redux/actions/cart'
import { useVirginSSOAuth } from '@/hooks/useVirginSSOAuth'
import { PrismicInStore } from '../interfaces/common/prismicInStore'
import { billingAddressForThermorCheckoutPut } from '@/utils/cart'

const mapStateToProps = (state: RootState) => ({
  promotions: state.promotions,
  user: state.user,
  parameters: state.parameters,
  cart: state.cart,
})

const mapDispatchToProps = {
  getCheckout: getCheckout,
  createCheckoutAdress: createCheckoutAdress,
  registerUser: registerUser,
  loginUser: loginUser,
  getUser: getUser,
  postAddress: postAddress,
  saveGhostUser: saveGhostUser,
  deleteGhostUser: deleteGhostUser,
  getLastUsedBillingAddress: getLastUsedBillingAddress,
  setInformationSkipped: setInformationSkipped,
}

type Tprops = {
  doc?: any
  main?: any
  basket?: any
  funnel?: any
  parameters?: any
  checkout: Cart
  promotions: any
  inStoreText: PrismicInStore
  account: any
  takeback: any
  faqRes?: any
  banner?: any
} & ReturnType<typeof mapStateToProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps>

const InformationPage = ({
  doc,
  main,
  basket,
  funnel,
  parameters,
  getCheckout,
  createCheckoutAdress,
  loginUser,
  user,
  takeback,
  postAddress,
  inStoreText,
  promotions,
  registerUser,
  getUser,
  account,
  saveGhostUser,
  deleteGhostUser,
  faqRes,
  banner,
  cart,
  setInformationSkipped,
  getLastUsedBillingAddress,
}: Tprops) => {
  const classes = useFunnelStyle()
  const router = useRouter()

  const dispatch = useDispatch()

  const funnelStep = cart?.funnelStep
  const [error] = useState({ field: '', message: '' })
  const [login, setIsLoginForm] = useState(false)

  const [register, setIsRegisterForm] = useState(false)

  const [ghostUser, setIsGhostUser] = useState(false)

  const [hasRegistered, setHasRegistered] = useState(false)

  const [errorPhone, setHasErrorPhone] = useState(false)
  const [errorAccountDisabled, setErrorAccountDisabled] = useState(false)
  const [errorEmailUsed, setErrorEmailUsed] = useState(false)
  const [forgot, setIsForgotForm] = useState(false)
  const [loginError, setLoginError] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [isConnected, setIsConnected] = useState(false)
  const [hasLogin, setHasLogin] = useState(false)
  const hasStockError = useCartHasStockError()
  const { t } = useTranslation()

  const { trackPageView, trackEvent } = useMatomo()

  const isLoginFirst = doc?.data?.first_form_to_show
  const funnelContentRef = useRef(null)

  const store = process.env.STORE
  const isVirginUser = store === 'virgin'

  const { isCheckingAuth } = isVirginUser
    ? useVirginSSOAuth(router, false)
    : { isCheckingAuth: false }

  const backToInformation = useMemo(
    () => doc?.data?.enable_back_to_informations,
    [doc?.data?.enable_back_to_informations]
  )

  const information = useMemo(() => {
    const billingAddress = cart?.item?.billingAddress
    const { address, ...userInfos } = user?.user || {}
    if (billingAddress) {
      return { ...billingAddress, ...(userInfos && { ...userInfos }) }
    } else if (address) {
      return {
        ...address,
        email: user?.user?.email,
      }
    }
    return null
  }, [cart?.item?.billingAddress, user?.user])

  const redirectToShipping = () => {
    if (hasStockError) return
    router.push('/shipping')
  }

  useEffect(() => {
    dispatch(
      SAVE_PRISMIC_DOCUMENTS({
        general: main?.data,
        funnel: funnel?.data,
        account: account?.data,
        basket: basket?.data,
        instore: inStoreText?.data,
      })
    )
  }, [funnel, main, account, basket, inStoreText])

  useEffect(() => {
    {
      // Redirect to shop page if no products in cart
      cart && cart.item && cart.item.items.length === 0 && router.push('/shop')
      checkTryOutError(cart) && router.push('/shop')
    }
  }, [cart?.item?.items])

  useEffect(() => {
    if (user?.user?.id && !hasLogin) {
      setIsConnected(true)
      setIsLoginForm(false)
      setIsRegisterForm(false)
    } else {
      setIsConnected(false)
      if (isLoginFirst) {
        setIsLoginForm(true)
        setIsRegisterForm(false)
      } else if (cart?.item?.billingAddress && backToInformation) {
        setIsGhostUser(true)
        setIsLoginForm(false)
        setIsRegisterForm(false)
      } else {
        setIsLoginForm(false)
        setIsRegisterForm(true)
      }
    }
  }, [user?.user, hasLogin, cart?.item?.billingAddress, backToInformation])

  useEffect(() => {
    const shouldSkip =
      isConnected &&
      (!isB2B || (isB2B && cart?.item?.billingAddress)) &&
      !!user?.user?.address?.city &&
      (!backToInformation || (backToInformation && funnelStep !== 0))

    // Mémorise si l'étape /information est réellement sautée, pour masquer son
    // onglet dans le stepper des étapes suivantes (seulement si l'état change,
    // pour éviter des dispatch/re-renders inutiles).
    if (cart?.informationSkipped !== shouldSkip) {
      setInformationSkipped(shouldSkip)
    }

    if (shouldSkip) {
      getCheckout(cart?.item?.tokenValue)
      localStorage.setItem('email', user?.user?.email)
      //onSubmit(data)
      redirectToShipping()
    }
  }, [
    user?.user,
    isConnected,
    cart?.item?.billingAddress,
    cart?.informationSkipped,
    isB2B,
    backToInformation,
    funnelStep,
  ])

  useEffect(() => {
    if (isThermorSSO) return
    if (
      isB2B &&
      user?.user?.id &&
      !cart?.loading &&
      cart?.item &&
      !cart?.item?.billingAddress
    ) {
      const setLastUsedBillingAddress = async () => {
        const lastUsedBillingAddress = await getLastUsedBillingAddress()
        if (
          lastUsedBillingAddress &&
          Object.keys(lastUsedBillingAddress).length > 0
        ) {
          createCheckoutAdress(cart?.item?.tokenValue, {
            billingAddress: lastUsedBillingAddress,
          })
        }
      }
      setLastUsedBillingAddress()
    }
  }, [user?.user, cart, isB2B])

  const submitLogin = async (data) => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    const log = await loginUser(data)
    setLoginError(false)
    if (log.type === 'LOGIN_USER_FAILURE') {
      if (log?.err?.response?.data?.message === 'Account is disabled.') {
        setErrorAccountDisabled(true)
      } else {
        setLoginError(true)
        setIsConnected(false)
        setIsLoginForm(true)
      }
      return
    } else {
      setLoginError(false)
      setIsRegisterForm(false)
      setIsConnected(true)
      setIsLoginForm(false)
      if (log.token.token) {
        localStorage.setItem('TOKEN', log.token.token)
        getUser()
      }
    }
    if (user?.ghostUser) deleteGhostUser()
    redirectToShipping()
  }

  const submitRegistration = async (data) => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    setHasError(false)
    setErrorEmailUsed(false)
    setHasErrorPhone(false)

    if (
      ['MOBILE', 'FIXED_LINE_OR_MOBILE'].includes(
        parseMax(data?.phoneNumber).getType()
      )
    ) {
      const register = await registerUser(data)
      if (register.type === 'REGISTER_USER_SUCCESS') {
        trackEvent({
          category: `Information funnel`,
          action: 'Customer has successfully created his account',
        })
        if (!parameters?.items?.isAccountVerificationRequired) {
          const dataLogin = {
            email: data.email,
            password: data.plainPassword,
          }
          submitLogin(dataLogin)
          setIsRegisterForm(false)
          setIsLoginForm(true)
          setHasRegistered(true)
          setHasLogin(false)
        } else {
          setIsRegisterForm(false)
          setIsLoginForm(true)
          setHasRegistered(true)
        }
      } else {
        trackEvent({
          category: `Information funnel`,
          action: `Customer account creation failure`,
        })
        const err = register?.err?.response?.data?.errors?.email?.[0]
        if (err?.length > 0 && err === 'This email is already used.') {
          setErrorEmailUsed(true)
        } else {
          setHasError(true)
        }
      }
    } else {
      setHasErrorPhone(true)
    }
    if (user?.ghostUser) deleteGhostUser()
  }

  const switchForm = (id) => {
    setIsRegisterForm(false)
    setIsGhostUser(false)
    setIsConnected(false)
    setLoginError(false)
    setHasError(false)
    setErrorEmailUsed(false)
    setErrorAccountDisabled(false)
    setHasErrorPhone(false)
    setIsForgotForm(false)
    setIsLoginForm(false)
    switch (id) {
      case 1:
        setIsRegisterForm(true)
        trackEvent({
          category: `Information funnel`,
          action: `Open Registration Form`,
        })
        break
      case 2:
        setIsGhostUser(true)
        trackEvent({
          category: `Information funnel`,
          action: `Go as Ghost User`,
        })
        break
      case 3:
        setIsConnected(true)
        trackEvent({
          category: `Information funnel`,
          action: `Logged in successfully`,
        })
        break
      case 4:
        setIsLoginForm(true)
        trackEvent({
          category: `Information funnel`,
          action: `Open Login Form`,
        })
        break
      case 5:
        setIsForgotForm(true)
        trackEvent({
          category: `Information funnel`,
          action: `Open Forget password Form`,
        })
        break
      default:
        break
    }
  }

  useEffect(() => {
    trackPageView({ documentTitle: 'Information' })
    /*window?.scrollTo({
      top: funnelContentRef.current.offsetTop,
      behavior: 'smooth',
    })*/
  }, [switchForm])

  useEffect(() => {
    if (process.env.STORE_TYPE === 'classic_subscription') {
      promotions?.futurPrice === 0 && router.push('/shop')
    }
  }, [promotions])

  const onSubmit = async (
    shippingAddress: ShippingAddress,
    billingAddress?: BillingAddress
  ) => {
    setHasErrorPhone(false)
    if (
      shippingAddress?.phoneNumber &&
      ['MOBILE', 'FIXED_LINE_OR_MOBILE'].includes(
        parseMax(shippingAddress?.phoneNumber).getType()
      )
    ) {
      const checkoutInfos = {
        billingAddress: billingAddressForThermorCheckoutPut(
          billingAddress ?? shippingAddress,
          cart?.item
        ),
        shippingAddress,
      }
      if (cart?.item) {
        setHasError(false)
        setHasErrorPhone(false)
        const checkAddress: any = await createCheckoutAdress(
          cart.item.tokenValue,
          checkoutInfos
        )
        if (isB2B && isConnected) {
          await onConnectedSubmit(shippingAddress)
        } else {
          await getCheckout(cart?.item?.tokenValue)
          saveGhostUser({
            firstName: checkoutInfos.billingAddress.firstName,
            lastName: checkoutInfos.billingAddress.lastName,
            email: checkoutInfos.billingAddress.email,
          })
        }

        if (checkAddress.type === 'PUT_CHECKOUT_ADDRESS_SUCCESS') {
          setHasError(false)
          setHasErrorPhone(false)

          trackEvent({
            category: `Information funnel`,
            action: `Go to Shipping`,
          })
          redirectToShipping()
        } else if (checkAddress.type === 'PUT_CHECKOUT_ADDRESS_FAILURE') {
          if (
            checkAddress?.err?.response?.data?.message === 'Validation failed'
          ) {
            setHasErrorPhone(true)
            trackEvent({
              category: `Information funnel`,
              action: `Go to Shipping Fail, Incorrect Phone Number`,
            })
          } else {
            setHasError(true)
            setHasErrorPhone(false)
            trackEvent({
              category: `Information funnel`,
              action: `Go to Shipping Fail`,
            })
          }
        }
      }
    } else {
      setHasErrorPhone(true)
    }
  }

  const onConnectedSubmit = async (shippingAddress: ShippingAddress) => {
    setHasLogin(false)

    const userInfos = {
      firstName: user?.user?.firstName,
      lastName: user?.user?.lastName,
      phoneNumber: user?.user?.phoneNumber,
    }

    let billingInfos
    if (shippingAddress) {
      billingInfos = {
        ...userInfos,
        ...shippingAddress,
      }
      await postAddress(billingInfos)
      await getUser()
    }
    setHasLogin(true)
    cart?.item && (await getCheckout(cart.item.tokenValue))
    localStorage.setItem('email', user.user.email)
    trackEvent({
      category: `Information funnel`,
      action: `Logged user Go to Shipping`,
    })
    if (!isB2B) {
      redirectToShipping()
    }
  }

  return (
    <Layout
      mainLogo={main?.data?.logo}
      doc={main}
      metaTitle={prismicText(
        doc?.data?.meta_title_information,
        t('texts:funnel:information')
      )}
      hideTop
      t={t}
      inStoreText={inStoreText}
      metaDescription={doc?.data?.meta_description_information}
      metaKeywords={doc?.data?.meta_keywords_information}
      basket={basket}
      takeback={takeback}
      account={account}
      faq={faqRes}
      banner={banner}
    >
      <main className={clsx('information', 'checkout', classes.root)}>
        <div className={clsx('funnel', classes.funnel)}>
          <Container maxWidth={'xl'}>
            <div className={classes.funnelLayout}>
              <div className={classes.funnelContent} ref={funnelContentRef}>
                <FunnelHeader
                  title={
                    doc?.data?.steps?.[0]?.['title']?.[0]?.text
                      ? doc?.data?.steps?.[0]?.['title']?.[0]?.text
                      : t('texts:funnel:information')
                  }
                />
                <FunnelBox
                  steps={getStepperSteps(
                    doc?.data?.steps,
                    doc?.data?.order_reference_label
                  )}
                  t={t}
                  activeStep={0}
                >
                  <Link href={'/shop'} passHref>
                    <a
                      onClick={() =>
                        trackEvent({
                          category: `Information funnel`,
                          action: `Return to shop`,
                        })
                      }
                    >
                      <Typography
                        variant={'body2'}
                        className={clsx(classes.backLink, 'backLink')}
                        component="span"
                      >
                        <KeyboardBackspaceIcon className={classes.backArrow} />
                        <span>
                          <CMSText
                            asText
                            data={doc?.data?.return_button}
                            defaultText={t('texts:funnel:return_button')}
                          />
                        </span>
                      </Typography>
                    </a>
                  </Link>
                  {/* Show InformationForm if:
                      - User is a guest user (ghostUser) OR
                      - User is at the first funnel step (funnelStep === 0) and is connected AND
                      - Either user is not connected OR user has no city in address OR it's a B2B user
                      - And user data is not loading */}
                  {(ghostUser || (funnelStep === 0 && isConnected)) &&
                    !user.loading &&
                    (!(isConnected && !user?.user?.address?.city) ||
                      (isB2B && isConnected)) && (
                      <InformationForm
                        onSubmit={onSubmit}
                        switchForm={switchForm}
                        t={t}
                        information={information as BillingAddress}
                        error={error}
                        hasError={hasError}
                        errorPhone={errorPhone}
                        disabled={hasStockError}
                        text={doc?.data}
                        accountText={account?.data}
                        cart={cart}
                        generalConfigData={main?.data}
                        prismicFunnelData={doc?.data}
                        prefill={!!information}
                      />
                    )}
                  {login && (
                    <LoginForm
                      hasRegistered={hasRegistered}
                      submitLogin={submitLogin}
                      loginError={loginError}
                      t={t}
                      errorAccountDisabled={errorAccountDisabled}
                      switchForm={switchForm}
                      isLoading={user.loading}
                      text={account?.data}
                      isFunnel={true}
                    />
                  )}
                  {register && (
                    <RegisterForm
                      submitRegistration={submitRegistration}
                      switchForm={switchForm}
                      isLoading={user.loading}
                      errorPhone={errorPhone}
                      t={t}
                      errorEmailUsed={errorEmailUsed}
                      hasError={hasError}
                      text={account?.data}
                      isFunnel={true}
                      generalConfigData={main?.data}
                    />
                  )}
                  {!isB2B && isConnected && !user?.user?.address?.city && (
                    <>
                      {!hasLogin ? (
                        <ConnectedForm
                          onSubmit={onConnectedSubmit}
                          text={account?.data}
                          t={t}
                          switchForm={switchForm}
                          userFirstName={user?.user?.firstName}
                          hasAddress={user?.user}
                          funnel={funnel}
                        />
                      ) : (
                        <div className={classes.loaderContainer}>
                          <Loader />
                        </div>
                      )}
                    </>
                  )}
                  {forgot && (
                    <ForgotPasswordForm
                      isFunnel={true}
                      t={t}
                      text={account?.data}
                      switchForm={switchForm}
                    />
                  )}
                </FunnelBox>
              </div>
              <div className={classes.funnelAside}>
                <FunnelAside
                  text={funnel?.data}
                  basket={basket}
                  parameters={parameters}
                  settings={main}
                  takeback={takeback}
                />
              </div>
            </div>
          </Container>
        </div>
      </main>
    </Layout>
  )
}

export async function getStaticProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)

  const general = await getSingleDocument(client, lang, 'general')
  const takeback = await getSingleDocument(client, lang, 'take_back')
  const basket = await getSingleDocument(client, lang, 'basket')
  const funnel = await getSingleDocument(client, lang, 'funnel')
  const account = await getSingleDocument(client, lang, 'account')
  const inStoreText = await getSingleDocument(client, lang, 'instore')
  const faqRes = await getSingleDocument(client, lang, 'faq')
  const banner = await getSingleDocument(client, lang, 'banner')

  return {
    props: {
      doc: funnel,
      main: general,
      takeback,
      basket,
      funnel,
      account,
      inStoreText,
      faqRes,
      banner,
      i18nResources: await getTranslations(locale, ['texts']),
    },
    revalidate: 300,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InformationPage)
